import { useQueryParamsStore } from '../store/useQueryParamsStore';

export class QueryParamsService {
  constructor() {
    this.store = useQueryParamsStore;
    this.isBrowser = typeof window !== 'undefined';
  }

  // Initialize and parse query params (call this once in your app)
  initialize() {
    if (!this.isBrowser) return;

    const searchParams = new URLSearchParams(window.location.search);
    const urlToken = searchParams.get('token');
    const urlIssueKey = searchParams.get('issueKey');

    // Only set if both parameters are present
    if (urlToken && urlIssueKey) {
      this.store.getState().setParams(urlToken, urlIssueKey);
    }
  }

  // Get current values
  getParams() {
    const { token, issueKey, rateLimitId } = this.store.getState();
    return { token, issueKey, rateLimitId };
  }
  
  getIssueKey() {
    const { issueKey } = this.store.getState();
    return issueKey;
  }
  
  getCacheKey() {
    const { token, issueKey } = this.store.getState();
    return this.getCacheKeyString(issueKey, token);
  }
  
  getCacheKeyString(issueKey, token) {
    return issueKey + '-' + token;
  }

  // Update values
  setParams(token, issueKey) {
    this.store.getState().setParams(token, issueKey);
  }

  // Check if params are available
  hasParams() {
    const { token, issueKey } = this.store.getState();
    return !!(token && issueKey);
  }
}

export const queryParamsService = new QueryParamsService();

// Reads token/issueKey directly from the URL, synchronously — for use as a
// per-ticket storage-partition key at module-eval time, before React mounts
// and before the queryParamsStore itself has been populated via initialize().
// Without this, stores that persist a single flat "current SOW" value to a
// fixed IndexedDB record would share that record across every ticket tab on
// the origin.
export const DEFAULT_CACHE_KEY = 'default';

export const getUrlCacheKey = () => {
  if (typeof window === 'undefined') return DEFAULT_CACHE_KEY;
  const searchParams = new URLSearchParams(window.location.search);
  const token = searchParams.get('token');
  const issueKey = searchParams.get('issueKey');
  return token && issueKey ? queryParamsService.getCacheKeyString(issueKey, token) : DEFAULT_CACHE_KEY;
};